export default {
	namespaced: true,
	state: () => ({
		countDown: 0,
	}),
	mutations: {
		setCountdown(state, data) {
			state.countDown = data;
		},
	},
	getters: {
		countdown(state) {
			return state.countDown;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Fission/fissionV4.js